module.exports = __webpack_public_path__ + "img/email-24px.694954db.svg";